import type { EquipeVaziaProps } from "./types-equipe-vazia";
import { EquipeVaziaView } from "./view-equipe-vazia";

export function EquipeVazia(props: EquipeVaziaProps) {
  return <EquipeVaziaView {...props} />;
}

export { CalendarioVazio } from "./view-equipe-vazia";

export type * from "./types-equipe-vazia";
